
//Get
const MESSAGE_TEMPLATES_LIST_GET_DATA = {
    MESSAGE_TEMPLATES_LIST_GET_DATA_LOAD: "MESSAGE_TEMPLATES_LIST_GET_DATA_LOAD",
    MESSAGE_TEMPLATES_LIST_GET_DATA_SUCCESS: "MESSAGE_TEMPLATES_LIST_GET_DATA_SUCCESS",
    MESSAGE_TEMPLATES_LIST_GET_DATA_FAIL: "MESSAGE_TEMPLATES_LIST_GET_DATA_FAIL",
};

const MESSAGE_TEMPLATES_LIST_GET_DETAIL_API = "tickets/message-templates/list";

// create / update template
const MESSAGE_TEMPLATE_POST = {
    MESSAGE_TEMPLATE_POST_LOAD: "MESSAGE_TEMPLATE_POST_LOAD",
    MESSAGE_TEMPLATE_UPDATE_LOAD: "MESSAGE_TEMPLATE_UPDATE_LOAD",
    MESSAGE_TEMPLATE_POST_SUCCESS: "MESSAGE_TEMPLATE_POST_SUCCESS",
    MESSAGE_TEMPLATE_POST_FAIL: "MESSAGE_TEMPLATE_POST_FAIL",
};
const MESSAGE_TEMPLATE_POST_API = "tickets/message-templates";
const MESSAGE_TEMPLATE_UPDATE_API = "tickets/message-templates"; // + /{id}
// DELETE template
const MESSAGE_TEMPLATE_DELETE = {
  MESSAGE_TEMPLATE_DELETE_LOAD: "MESSAGE_TEMPLATE_DELETE_LOAD",
  MESSAGE_TEMPLATE_DELETE_SUCCESS: "MESSAGE_TEMPLATE_DELETE_SUCCESS",
  MESSAGE_TEMPLATE_DELETE_FAIL: "MESSAGE_TEMPLATE_DELETE_FAIL",
};

// ENABLE / DISABLE template
const MESSAGE_TEMPLATE_STATUS = {
  MESSAGE_TEMPLATE_STATUS_LOAD: "MESSAGE_TEMPLATE_STATUS_LOAD",
  MESSAGE_TEMPLATE_STATUS_SUCCESS: "MESSAGE_TEMPLATE_STATUS_SUCCESS",
  MESSAGE_TEMPLATE_STATUS_FAIL: "MESSAGE_TEMPLATE_STATUS_FAIL",
};

// APIs (dummy for now – structure ready)
const MESSAGE_TEMPLATE_DELETE_API = "tickets/message-templates/delete";
const MESSAGE_TEMPLATE_STATUS_API = "tickets/message-templates";

// GET template by id
const MESSAGE_TEMPLATE_GET = {
  MESSAGE_TEMPLATE_GET_LOAD: "MESSAGE_TEMPLATE_GET_LOAD",
  MESSAGE_TEMPLATE_GET_SUCCESS: "MESSAGE_TEMPLATE_GET_SUCCESS",
  MESSAGE_TEMPLATE_GET_FAIL: "MESSAGE_TEMPLATE_GET_FAIL",
  MESSAGE_TEMPLATE_GET_CLEAR: "MESSAGE_TEMPLATE_GET_CLEAR",
};

// API
const MESSAGE_TEMPLATE_GET_API = "tickets/message-templates"; // + /{id}
export {
    MESSAGE_TEMPLATES_LIST_GET_DATA,
    MESSAGE_TEMPLATES_LIST_GET_DETAIL_API,
    MESSAGE_TEMPLATE_POST,
    MESSAGE_TEMPLATE_POST_API,
    MESSAGE_TEMPLATE_DELETE,
    MESSAGE_TEMPLATE_STATUS,
    MESSAGE_TEMPLATE_DELETE_API,
    MESSAGE_TEMPLATE_STATUS_API,
    MESSAGE_TEMPLATE_GET,
    MESSAGE_TEMPLATE_GET_API,
    MESSAGE_TEMPLATE_UPDATE_API,
};